module.exports = __webpack_public_path__ + "static/media/heart22.76ec178a.svg";